import { render } from "./SvgImage.vue?vue&type=template&id=3b8e0fbf"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__